import type { Talk } from '../types/content'

export const talks: Talk[] = [
  {
    title: 'Building companies where the infrastructure isn’t',
    event: 'Africa Tech Summit',
    location: 'Nairobi',
    year: '2026',
    format: 'Keynote',
  },
  {
    title: 'The next generation of emerging managers',
    event: 'SuperReturn',
    location: 'Berlin',
    year: '2026',
    format: 'Panel',
  },
  {
    title: 'What founders actually need from capital',
    event: 'Slush',
    location: 'Helsinki',
    year: '2025',
    format: 'Fireside',
  },
  {
    title: 'Designing ecosystems that outlive their funding',
    event: 'World Economic Forum',
    location: 'Davos',
    year: '2025',
    format: 'Panel',
  },
  {
    title: 'Venture building in frontier markets',
    event: 'Web Summit',
    location: 'Lisbon',
    year: '2025',
    format: 'Keynote',
  },
  {
    title: 'Operator to investor: crossing the table',
    event: 'Y Combinator Founder Summit',
    location: 'San Francisco',
    year: '2024',
    format: 'Fireside',
  },
  {
    title: 'Public capital, private speed',
    event: 'IFC Global Forum',
    location: 'Washington DC',
    year: '2024',
    format: 'Workshop',
  },
  {
    title: 'The economics of opportunity',
    event: 'TEDx Lagos',
    location: 'Lagos',
    year: '2024',
    format: 'Keynote',
  },
]

export const speakingTopics = [
  {
    title: 'Venture building & company creation',
    body: 'How companies get built where the infrastructure is still being written — and what that demands of founders.',
  },
  {
    title: 'Capital, access & emerging managers',
    body: 'The changing shape of early-stage capital, and why the next decade belongs to operator-investors.',
  },
  {
    title: 'Ecosystems & public-private strategy',
    body: 'Designing the connective tissue between policy, institutions and founders so markets actually compound.',
  },
  {
    title: 'Leadership for the second act',
    body: 'What it takes to lead through the step change from proving a product to running a company.',
  },
]

export const featuredEvents = [
  'Africa Tech Summit',
  'World Economic Forum',
  'Slush',
  'Web Summit',
  'SuperReturn',
  'Y Combinator',
  'TEDx',
  'IFC Global Forum',
  'Norrsken',
  'GITEX',
]
